import { render, staticRenderFns } from "./Geophysics.vue?vue&type=template&id=18c16495"
import script from "./Geophysics.vue?vue&type=script&lang=js"
export * from "./Geophysics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports